import { IMenuGroup } from '../../interfaces/menu-items/IMenuGroup';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PieChartIcon from '@mui/icons-material/PieChart';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const MenuGroups: IMenuGroup[] = [
    {
        label: 'Principal',
        items: [
            { id: 1, name: 'Dashboard', url: 'dashboard', icon: DashboardIcon },
        ],
    },
    {
        label: 'Registos',
        items: [
            { id: 2, name: 'Gestão de Moedas',   url: 'cryptocurrency', icon: CurrencyBitcoinIcon },
            { id: 3, name: 'Gestão de Carteira', url: 'wallet',         icon: AccountBalanceWalletIcon },
        ],
    },
    {
        label: 'Operações',
        items: [
            { id: 4, name: 'Gestão de Transações',      url: 'transaction',    icon: SwapHorizIcon },
            { id: 5, name: 'Balanceamento de Portfolio', url: 'balancing',     icon: PieChartIcon },
            { id: 6, name: 'Pools de Liquidez',          url: 'liquidity-pool', icon: WaterDropIcon },
        ],
    },
];

export default MenuGroups;
